/** 错误分流:toast 走 Toast.error,sold-out 走门票售空独立 popup(UI-SPEC §4.7) */
export type PopupKind = 'toast' | 'sold-out';

export type ErrorBusiness = {
  message: string;
  popupKind: PopupKind;
};

/**
 * mets 活动业务错误码 → 英文文案 + 分流类型。
 * D-04 sites=['US'],全部英文。
 * 编码映射参考 mets-shared/error-codes.ts 31001-31005(最高频 5 条)。
 * 其他码(31006-31012)走默认兜底 + toast。
 *
 * 特殊路由(UI-SPEC §4.7):
 * - 31003 EVENT_INVALID / 31005 OUT_OF_STOCK → popupKind='sold-out' 走门票售空 popup
 * - 其余业务错 → popupKind='toast' 走 Toast.error
 */
export function getBusinessErrorMessage(code: number): ErrorBusiness {
  switch (code) {
    case 31001: // ORDER_INVALID
      return {
        message: 'Order not found or invalid.',
        popupKind: 'toast',
      };
    case 31002: // TASK_NOT_COMPLETED
      return {
        message: 'Please complete the unlock task first.',
        popupKind: 'toast',
      };
    case 31003: // EVENT_INVALID / 场次不可兑换
      return {
        message: 'Tickets are sold out.',
        popupKind: 'sold-out',
      };
    case 31004: // REDEEM_DEADLINE_PASSED
      return {
        message: 'The redemption window has closed.',
        popupKind: 'toast',
      };
    case 31005: // OUT_OF_STOCK
      return {
        message: 'Tickets are sold out.',
        popupKind: 'sold-out',
      };
    default:
      return {
        message: 'Operation failed, please try again.',
        popupKind: 'toast',
      };
  }
}
